let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aHD9Z")).then(() => parcelRequire('537Fw'));